import { ChatkeeperRequestTypeEnum } from "../types"

export abstract class ChatkeeperIntegrationRequest {
  abstract type:ChatkeeperRequestTypeEnum
  token!: string
}
